"use strict";
// @ts-ignore
try {
    self['workbox:precaching:7.4.0'] && _();
}
catch (e) { }
